import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch, useSelector } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { AddInvestmentApi, CreateInvestorApi } from "../../ApiRequests"; // Updated API function
import AuthBtn from "../Buttons/AuthBtn";
import { fetchInvestor } from "../../store/Slices/InvestorSlice";
import InvestorSelector from "../Selector/InvestorSelector";

const AddInvestmentModal = ({ Open, setOpen }) => {
  const [Loading, setLoading] = useState(false);
  const [SelectedInvestor, setSelectedInvestor] = useState("");
  const [Amount, setAmount] = useState(0);

  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (SelectedInvestor === "") {
      WarningToast("Enter a Select Investor");
    } else if (Amount === "" || Amount <= 0) {
      WarningToast("Enter a valid amount");
    } else {
      try {
        const response = await AddInvestmentApi(SelectedInvestor._id, {
          investor_name: SelectedInvestor.name,
          amount: Number(Amount),
        });
        if (response.data.success) {
          setOpen(false);
          SuccessToast("Investment added successfully");
          dispatch(fetchInvestor());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.log(err);
        ErrorToast("Failed to add investment");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Add Investment
        </h1>
        <div className="flex flex-col px-10 gap-y-4">
          <InvestorSelector
            SelectedInvestor={SelectedInvestor}
            setSelectedInvestor={setSelectedInvestor}
          />
          <AuthInput
            label="Amount"
            placeholder="Enter Amount"
            Value={Amount}
            setValue={setAmount}
            Type={"number"}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {Loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Add Investment"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default AddInvestmentModal;
